import React from "react";
import classes from "./InvoiceDateReciptNew.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BarChart2,
  Filter,
  CalendarClock,
  Mail,
  ArrowLeft,
  Printer,
  Download,
  Settings,
} from "lucide-react";

const InvoiceDateReciptNew = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { invoiceNumber, invoiceDate, dueDate, customer, items, total } = location.state || {};

  const vat = total * 0.075;
  const discount = 0;
  const grandTotal = total + vat - discount;

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  if (!location.state) {
    return (
      <div className={classes.errorPage}>
        <h2>Invoice data not found.</h2>
        <button onClick={() => navigate("/dashboard")}>Go to Dashboard</button>
      </div>
    );
  }

  const printInvoice = () => {
    window.print();
  };

  return (
    <div>
      <div className={classes.noPrint}>
        <HeaderNav activePage={pageMap[location.pathname]} />
      </div>
      <div className={classes.Container}>
        {/* Action Buttons */}
        <div className={classes.actions}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>
        <div className={classes.act}>
          <form className={classes.form}>
            <div className={classes.group}>
              <label>Period:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>Current month</option>
                  <option>Cash</option>
                  <option>Cheque</option>
                  <option>Transfer</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>Group by:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>None</option>
                  <option>Cash</option>
                  <option>Cheque</option>
                  <option>Transfer</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>Start Date:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>30/02/25</option>
                  <option>12/07/25</option>
                  <option>03/04/25</option>
                  <option>27/01/25</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>End Date:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>30/02/25</option>
                  <option>12/07/25</option>
                  <option>03/04/25</option>
                  <option>27/01/25</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <button className={classes.greenBtn}>
                <BarChart2 size={16} style={{ marginRight: "6px" }} />
                Run Report
              </button>
            </div>
          </form>

          <div className={classes.iconbars}>
            <div className={classes.iconbarr}>
              <div className={classes.iconbar}>
                <Filter size={16} style={{ marginRight: "6px" }} />
                Filter
              </div>
              <div className={classes.iconbar}>
                <CalendarClock size={16} style={{ marginRight: "6px" }} />
                Schedule
              </div>
            </div>
            <div className={classes.iconbarss}>
              <div className={classes.iconbar}>
                <Mail size={16} />
              </div>
              <div className={classes.iconbar}>
                <Printer size={16} onClick={printInvoice} />
              </div>
              <div className={classes.iconbar}>
                <Download size={16} />
              </div>
              <div className={classes.iconbar}>
                <Settings size={16} />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.matron}>
          <button className={classes.backButton} onClick={() => navigate(-1)}>
            <ArrowLeft size={16} style={{ marginRight: "6px" }} />
          </button>
        </div>
        <div className={`${classes.containere} ${classes.printable}`}>
          <div className={classes.firstbar}>
            <div className={classes.promixfirst}>
              <div className={classes.pro1}>
                <h1 className={classes.companyName}>Promix Accounting Ltd</h1>
                <div className={classes.procs}>
                  <h2 className={classes.pro2}>123 Business District Victoria Island, Lagos Nigeria</h2>
                  <h2 className={classes.pro2}>+234 801 234 5678</h2>
                  <h2 className={classes.pro2}>hello@promix.com</h2>
                </div>
                <div className={classes.profirst}>
                  <div className={classes.call}>
                    <h2 className={classes.pro2}>Invoice#</h2>
                    <h2 className={classes.pro2}>Invoice Date</h2>
                    <h2 className={classes.pro2}>Terms</h2>
                    <h2 className={classes.pro2}>Due Date</h2>
                  </div>
                  <div className={classes.resp}>
                    <h2 className={classes.pro2}>{invoiceNumber}</h2>
                    <h2 className={classes.pro2}>{invoiceDate}</h2>
                    <h2 className={classes.pro2}>Due on receipt</h2>
                    <h2 className={classes.pro2}>{dueDate}</h2>
                  </div>
                </div>
              </div>

              <div className={classes.prosecond}>
                <h1 className={classes.prosec}>Invoice</h1>
              </div>

              <div className={classes.prothird}>
                <h2 className={classes.pro3}>From</h2>
                <h2 className={classes.pro4}>Bill To</h2>
              </div>

              <div className={classes.profourth}>
                <div className={classes.pro1}>
                  <h1 className={classes.companyName}>Promix Accounting Ltd</h1>
                  <div className={classes.procs}>
                    <h2 className={classes.pro2}>123 Business District Victoria Island, Lagos Nigeria</h2>
                    <h2 className={classes.pro2}>+234 801 234 5678</h2>
                  </div>
                  <h2 className={classes.pro2}>hello@promix.com</h2>
                </div>
                <div className={classes.pro1}>
                  <h1 className={classes.companyName}>{customer || "Customer Name"}</h1>
                  <div className={classes.procs}>
                    <h2 className={classes.pro2}>123 Business District Victoria Island, Lagos Nigeria</h2>
                    <h2 className={classes.pro2}>+234 801 234 5678</h2>
                    <h2 className={classes.pro2}>hello@customer.com</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.tableContainer}>
            <table className={classes.table}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th>Description</th>
                  <th>QTY</th>
                  <th>Rate</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {items?.map((item, index) => (
                  <tr key={index} className={classes.tableRow}>
                    <td>
                      <div>
                        <div style={{ fontWeight: "600", fontSize: "14px" }}>
                          {customer?.name || "Customer Name"}
                        </div>
                        <div style={{ fontSize: "13px", color: "#444" }}>
                          {item.description}
                        </div>
                      </div>
                    </td>
                    <td className={classes.qtyCell}>{item.qty}</td>
                    <td>₦{Number(item.price).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                    <td>₦{Number(item.total).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  </tr>
                ))}
              </tbody>


            </table>
          </div>
          <div className={classes.lastbar}>
            <div className={classes.termsandcondi}>
              <div className={classes.pront}>
                <h1 className={classes.companyNames}>Terms and conditions</h1>
                <div className={classes.procst}>
                  <h2 className={classes.pro6}>This invoice adheres to the policies and guidelines set forth by</h2>
                  <h2 className={classes.pro6}>Promix Accounting Ltd. Please review the terms carefully to</h2>
                  <h2 className={classes.pro6}>ensure compliance.</h2>
                </div>
              </div>
              <div className={classes.procsetion}>
                <div className={classes.procset}>
                  <h2 className={classes.pro5}>Total</h2>
                  <h2 className={classes.pro5}>VAT (7.5%)</h2>
                  <h2 className={classes.pro5}>Discount</h2>
                </div>
                <div className={classes.procset2}>
                  <h2 className={classes.pro5}>₦{total?.toLocaleString()}</h2>
                  <h2 className={classes.pro5}>₦{vat?.toLocaleString()}</h2>
                  <h2 className={classes.pro5}>-₦{discount?.toLocaleString()}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default InvoiceDateReciptNew;
